<template>
  <div>
    <div class="container-sit container-fluid">
      <div class="card card__out">
        <div class="info">
          <span class="title">{{translation.waiting}}</span>
          <div
            class="value"
            v-html="this.waiting"
          ></div>
        </div>
        <div class="info">
          <span class="title">{{translation.available}}</span>
          <div
            class="value"
            v-html="this.available"
          ></div>
        </div>
        <div class="info">
          <span class="title">{{translation.requested}}</span>
          <div
            class="value"
            v-html="this.requested"
          ></div>
        </div>
        <div class="info">
          <span class="title">{{translation.paid}}</span>
          <div
            class="value"
            v-html="this.paid"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "all-values-user",
  props: ["props"],
  components: {},
  data() {
    return {
      allValues: {},
      waiting: "",
      available: "",
      requested: "",
      paid: "",
      translation : this.$parent.$parent.view.translation.allValuesUser
    };
  },
  methods: {
    mountValues(usd, brl, eur) {
      //testar se os valores nao sao zerados
      if (this.testZeroValue(usd) && this.testZeroValue(brl) && this.testZeroValue(eur)) return '0';

      //se tiver valores vai montar o template
      return `
        <div class="${this.testZeroValue(usd) ? 'display-none':'value__show-flex'}">
          ${usd}&nbsp;<span>USD</span>
        </div>
        <div class="${this.testZeroValue(brl) ? 'display-none':'value__show-flex'}">
          ${brl}&nbsp;<span>BRL</span>
        </div>
        <div class="${this.testZeroValue(eur) ? 'display-none':'value__show-flex'}">
          ${eur}&nbsp;<span>EUR</span>
        </div>
    `;
    },
    testZeroValue(value) {
      if(value == 0 || value == '' || value == null) return true;
       return false;
    },
    handleJsonValues() {
      //console.log(this.props);
      this.waiting = this.mountValues(
        //se existe a chave ele inclui o valor se nao passa 0
       this.props.USD.A_RECEBER ? this.props.USD.A_RECEBER.valor : 0,
       this.props.BRL.A_RECEBER ? this.props.BRL.A_RECEBER.valor : 0,
       this.props.EUR.A_RECEBER ? this.props.EUR.A_RECEBER.valor : 0);
      this.available = this.mountValues(
        this.props.USD.NAO ? this.props.USD.NAO.valor : 0, 
        this.props.BRL.NAO ? this.props.BRL.NAO.valor : 0,
        this.props.EUR.NAO ? this.props.EUR.NAO.valor : 0);
      this.requested = this.mountValues(
       this.props.USD.SOLICITADO ? this.props.USD.SOLICITADO.valor : 0,
       this.props.BRL.SOLICITADO ? this.props.BRL.SOLICITADO.valor : 0,
       this.props.EUR.SOLICITADO ? this.props.EUR.SOLICITADO.valor : 0);
      this.paid = this.mountValues(
        this.props.USD.SIM ? this.props.USD.SIM.valor : 0,
        this.props.BRL.SIM ? this.props.BRL.SIM.valor : 0,
        this.props.EUR.SIM ? this.props.EUR.SIM.valor : 0);
    }
  },
  mounted() {
    this.handleJsonValues();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-sit{
  margin-left: 25px;
  margin-right: 25px;
  padding-right: 0;
  padding-left: 0;
  margin-bottom: 10px;
}
.card__out {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 0;
  .info {
    display: flex;
    align-items: center;
    .title {
      color: #818a91;
      //   font-weight: 700;
      font-size: 1rem;
      padding: 0.6em 0.7rem;
      background: #f8fafd;
      border-radius: 7px;
      margin-right: 0.2rem;
    }
    .value {
      font-size: 1rem;
      border-radius: 7px;
      background: var(--theme-color-accent);
      padding: 0.5em 1.3rem;
      color: white;
      font-weight: 700;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
<style>
.value__show-flex {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/allValuesUser.vue